import React from "react";
import SportCode from "components/common/SportCode";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import SvgMirs from "components/presentation/SvgMirs";


export function ScoreContainer(props) {
  const { resultObj, matchHasIrm } = props;
  const { mirs_discipline } = useUrlFriendlyToParameters()
  const winner = resultObj?.wlt === 'W' && <div className='score-winner'><SvgMirs className='mirsIcon score-winner' title='HeaderWinner' code='circle-check' /></div>

  let scoreSet1;
  let scoreSet2;
  let scoreSet3;

  if (resultObj?.extra?.resultS1) {
    if (resultObj?.extra?.resultS1.indexOf('(') === -1 && resultObj?.extra?.resultS1.length > 0) {
      scoreSet1 = <>
        {resultObj?.extra?.resultS1}
      </>
        ;
    } else if (resultObj?.extra?.resultS1.indexOf('(') !== -1) {
      scoreSet1 = <>
        {resultObj?.extra?.resultS1.substring(0, resultObj?.extra?.resultS1.indexOf('('))}
        <span className="tie-break-ten"><sup>
          {resultObj?.extra?.resultS1.substring(resultObj?.extra?.resultS1.indexOf('('), resultObj?.extra?.resultS1.indexOf(')') + 1)}
        </sup></span>
      </>
    }
  }
  if (resultObj?.extra?.resultS2) {
    if (resultObj?.extra?.resultS2.indexOf('(') === -1 && resultObj?.extra?.resultS2.length > 0) {
      scoreSet2 = <>
        {resultObj?.extra?.resultS2}
      </>
        ;
    } else if (resultObj?.extra?.resultS2.indexOf('(') !== -1) {
      scoreSet2 = <>
        {resultObj?.extra?.resultS2.substring(0, resultObj?.extra?.resultS2.indexOf('('))}
        <span className="tie-break-ten"><sup>
          {resultObj?.extra?.resultS2.substring(resultObj?.extra?.resultS2.indexOf('('), resultObj?.extra?.resultS2.indexOf(')') + 1)}
        </sup></span>
      </>
    }
  }
  if (resultObj?.extra?.resultS3) {
    if (resultObj?.extra?.resultS3.indexOf('(') === -1 && resultObj?.extra?.resultS3.length > 0) {
      scoreSet3 =
        <>
          {resultObj?.extra?.resultS3}
        </>;
    } else if (resultObj?.extra?.resultS3.indexOf('(') !== -1) {
      scoreSet3 = <>
        {resultObj?.extra?.resultS3.substring(0, resultObj?.extra?.resultS3.indexOf('('))}
        <span className="tie-break-ten">
          <sup>
            {resultObj?.extra?.resultS3.substring(resultObj?.extra?.resultS3.indexOf('('), resultObj?.extra?.resultS3.indexOf(')') + 1)}
          </sup></span>
      </>
    }
  }


  return (

    <div className='score-result-container ten-container d-flex flex-row justify-content-end flex-nowrap align-items-center flex-grow-1'>
      <div className="score-result ">{winner}</div>
      <div className={`ten-score-result ${scoreSet1 && scoreSet1?.props?.children.includes('[') ? ' bracket' : ''}`}>{scoreSet1}</div>
      <div className={`ten-score-result ${scoreSet2 && scoreSet2?.props?.children.includes('[') ? ' bracket' : ''}`}>{scoreSet2}</div>
      <div className={`ten-score-result ${scoreSet3 && scoreSet3?.props?.children.includes('[') ? ' bracket' : ''}`}>{scoreSet3}</div>
      {matchHasIrm && !resultObj?.hasIRM && <div className="match-irm fw-bold"></div>}
      {resultObj?.hasIRM &&
        <div className="match-irm fw-bold">
          {resultObj?.irm === 'BYE'
            ? <SportCode discipline={mirs_discipline} code='BYE' entity='@CompetitorPlace' abbr={true} />
            : <SportCode discipline={mirs_discipline} code={resultObj?.irm} entity='@IRM' abbr={true} />
          }
        </div>
      }
    </div>

  )
}
